import { HTTP_CODE } from '../../utils/redirector-utils';

const minStoreDetailsPathLength = 7;

const isStoreDetailsPath = (path) => /^\/l\//.test(path) && path.split('/').length >= minStoreDetailsPathLength;

const isStoreFinderPath = (path) => {
  const pathArray = path.split('/');
  // console.warn(pathArray[2]);
  // console.warn(/(^[A-Z]{2}$|\bsearch|storeDirectory\b)/.test(pathArray[2]));
  // console.warn(pathArray[3]);
  // console.warn(/(^[A-Z]{2}$)/.test(pathArray[3]));
  if (path === '/l/') return true;
  return /(^[A-Z]{2}$|\bsearch|storeDirectory\b)/.test(pathArray[2]) || /(^[A-Z]{2}$)/.test(pathArray[3]);
};

export const isPathFormatSupported = (path) => isStoreDetailsPath(path);

export const isStoreIdValid = (storeId) => /^\d+$/.test(storeId) && (storeId?.length === 4 || storeId?.length === 3);

export const getStoreIdFromStoreDetailsPath = (path) => (isStoreDetailsPath(path) ? path.split('/')[6] : null);

export const invalidPathHandler = ({ path }) => {
  if (!isStoreFinderPath(path)) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `Invalid path ${path}`
    };
  }
  return null;
};

export const invalidStoreIdHandler = ({ storeId }) => {
  if (!isStoreIdValid(storeId)) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `Invalid Store ID ${storeId}`
    };
  }
  return null;
};

export const notFoundHandler = ({ data, storeId }) => {
  if (data && !data.storeSearch) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `Store ID ${storeId} not found`
    };
  }

  return null;
};
